import { render } from "./permissao-editar.vue?vue&type=template&id=4f6f4c90"
import script from "./permissao-editar.vue?vue&type=script&lang=js"
export * from "./permissao-editar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__